export default __webpack_public_path__ + "static/media/NEXT_ART_Bold.b2bf4013.otf";